// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1d-7";
export var adjustableWidthBorderHeld = "_1d-8";
export var arrow = "_1d-3";
export var arrowButton = "_1d-4";
export var headerCell = "_1d-0";
export var help = "_1d-2";
export var icon = "_1d-1";
export var iconWrapper = "_1d-6";
export var noBorder = "_1d-b";
export var nonAdjustableWidthBorder = "_1d-9";
export var nonAdjustableWidthBorderHeld = "_1d-a";
export var textButton = "_1d-5";